import {call, select} from 'redux-saga/effects'
import {SUBMIT, submitFailure, submitSuccess, submitWaiting} from "./actions";
import {StripeCheckout} from "../services";
import moment from 'moment';
import {sendToServer} from "../utils/sagas";

const formatDate = (date) => moment(date).format('M/D/YYYY');

function* saga(stripe = StripeCheckout.instance()) {
    yield* sendToServer({
        EVENT: SUBMIT,
        request: function* () {
            const registration = yield select(state => state.tandems.registration);
            const token = yield call([stripe, stripe.createChargeToken], {
                name:        'Paraglide Utah, LLC',
                description: `Tandem: ${formatDate(registration.day)} (${registration.time})`,
                email:       registration.email,
                amount:      18900
            });
            return {
                url:  '/api/tandem',
                data: {
                    name:  registration.name,
                    phone: registration.phone,
                    email: registration.email,
                    day:   formatDate(registration.day),
                    time:  registration.time,
                    token
                }
            };
        },
        waiting: submitWaiting,
        success: submitSuccess,
        failure: submitFailure
    });
}

export default saga;



// WEBPACK FOOTER //
// ./src/app/tandems/sagas.js